import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { OTPublisherComponent } from './ot-publisher.component';
import { OTSubscriberComponent } from './ot-subscriber.component';

@NgModule({
  imports: [OTSubscriberComponent, OTPublisherComponent],
  exports: [OTSubscriberComponent, OTPublisherComponent],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class OpentokModule {}
